import { Box, Typography } from "@mui/material";
import { Listing, PaymentTerms } from "../../../types";
import CheckItem from "../common/check-item";
import { format } from "date-fns";
import InfoCell from "../../../../common/components/ui-kit/info-cell";

export default function RentalTerms({ listing }: { listing: Listing }) {
  return (
    <Box
      sx={(theme) => ({
        backgroundColor: theme.nawy.colors.semantic.layer.primary,
        p: theme.nawy.spacing.md,
        display: "flex",
        flexDirection: "column",
        gap: theme.nawy.spacing.lg,
        borderRadius: theme.nawy.radius.xl,
      })}
    >
      <Box
        sx={(theme) => ({
          display: "flex",
          flexDirection: "column",
          gap: theme.nawy.spacing.sm,
        })}
      >
        <Typography
          sx={(t) => t.nawy.typography.english.variants.body.md.semibold}
        >
          Rental terms
        </Typography>
        <Box
          sx={(t) => ({
            display: "flex",
            flexWrap: "wrap",
            gap: t.nawy.spacing["2xl"],
          })}
        >
          <InfoCell
            title="Showing start date"
            description={
              listing.propertyRental.showingFrom
                ? format(
                    new Date(listing.propertyRental.showingFrom),
                    "d MMM yyyy"
                  )
                : "N/A"
            }
          />
          <InfoCell
            title="Rental start date"
            description={
              listing.propertyRental.availableFrom
                ? format(
                    new Date(listing.propertyRental.availableFrom),
                    "d MMM yyyy"
                  )
                : "N/A"
            }
          />
          <InfoCell
            title="Payment terms"
            description={
              listing.propertyRental.paymentTerms
                ? PaymentTerms[listing.propertyRental.paymentTerms]
                : "N/A"
            }
          />
          <InfoCell
            title="Minimum stay duration"
            description={
              listing.propertyRental.minimumStayMonths
                ? `${listing.propertyRental.minimumStayMonths?.toString()} months`
                : "N/A"
            }
          />
        </Box>
      </Box>
      <Box
        sx={(t) => ({
          display: "flex",
          alignItems: "center",
          gap: t.nawy.spacing.xl,
        })}
      >
        <CheckItem
          text="Broker commission"
          isTrue={!listing.propertyRental.noBrokerCommission}
        />
        <CheckItem
          text="Insurance deposit"
          isTrue={listing.propertyRental.insuranceDepositRequired}
        />
        <CheckItem text="Furnished" isTrue={listing.propertyRental.furnished} />
      </Box>
    </Box>
  );
}
